module.exports = __webpack_public_path__ + "img/banner-1.7136f16c.jpg";